<div class="file-upload-container">
  <input
    type="file"
    multiple
    (change)="onFileSelected($event)"
    hidden
    #fileInput
  />

  <!-- Upload Area -->
  <div
    class="upload-area"
    [class.drag-over]="isDragOver"
    (drop)="onDrop($event)"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (click)="fileInput.click()"
  >
    <div class="upload-content">
      <mat-icon class="attach-icon">attach_file</mat-icon>
      <div class="upload-text">
        <span class="upload-primary">Click to upload or drag and drop</span>
        <span class="upload-secondary">Maximum file size: 10 MB</span>
        <span class="upload-secondary"
          >File Types: jpg, png, pdf, doc, docx, xls, xlsx, gpx</span
        >
      </div>
    </div>

    <!-- Success Animation -->
    <div class="success-animation" *ngIf="showSuccessAnimation">
      <div class="thumbs-up-container">
        <mat-icon class="thumbs-up-icon">thumb_up</mat-icon>
      </div>
      <div class="fireworks">
        <span class="firework" *ngFor="let i of fireworksCount"></span>
      </div>
    </div>
  </div>

  <!-- File List -->
  <div class="file-list-container" *ngIf="(allFiles$ | async)?.length > 0">
    <div class="file-list">
      <ciao-individual-file-bar
        class="file-item"
        *ngFor="let file of allFiles$ | async; let i = index"
        [file]="file"
        (removeFile)="deleteFile(file)"
      >
      </ciao-individual-file-bar>
    </div>
  </div>
</div>
